/* tslint:disable:max-line-length */

import React from 'react';
import { ApolloProvider } from 'react-apollo';
import * as Sentry from '@sentry/browser';
import { Route, Switch } from 'react-router-dom';
import {
  DashboardRoutes,
  DemographicsRoutes,
  ForgotPasswordRoutes,
  FulfillmentCentersRoutes,
  FulfillmentCenterDeliveryManagementRoutes,
  Home,
  HealthRoute,
  Login,
  MenuRoutes,
  OnboardingRoutes,
  ReportRoutes,
  UserRoutes,
  VenueManageRoutes,
  SquareCallback,
  OrderRoutes,
} from './routes';
import { PrivateRoute } from './PrivateRoute';

export default class App extends React.PureComponent<any, { hasError: boolean; errorEventId?: string }> {
  constructor(props) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      const errorEventId = Sentry.captureException(error);
      this.setState({ errorEventId });
    });
  }

  render() {
    const { client } = this.props;

    if (this.state.hasError) {
      return (
        <div className='centered-block text-center'>
          <p>Sorry the app crashed. We're looking into it!</p>
          {this.state.errorEventId && <p>(Error event ID: {this.state.errorEventId})</p>}
        </div>
      );
    }

    return (
      <ApolloProvider client={client}>
        <Switch>
          <Route exact={true} path='/' component={Login} />
          <Route exact={true} path='/health' component={HealthRoute} />
          <Route exact={true} path='/square-cb' component={SquareCallback} />
          <Route exact={true} path='/forgot-password' component={ForgotPasswordRoutes.ForgotPassword} />

          <Route exact={true} path='/onboarding/:uuid' component={OnboardingRoutes.OnboardingContainer} />
          <Route exact={true} path='/onboarding/:uuid/venue' component={OnboardingRoutes.OnboardingContainer} />

          <PrivateRoute path='/venue/:venueId/dashboard' component={DashboardRoutes.Dashboard} />

          <PrivateRoute path='/venue/:venueId/demographics' component={DemographicsRoutes.Demographics} />

          <PrivateRoute
            path='/venue/:venueId/fulfillment-centers'
            component={FulfillmentCentersRoutes.FulfillmentCenters}
            exact={true}
          />

          <PrivateRoute
            path='/venue/:venueId/fulfillment-centers/:fulfillmentCenterId/delivery'
            component={FulfillmentCenterDeliveryManagementRoutes.FulfillmentCentersDeliveryIndex}
            exact={true}
          />
          <PrivateRoute
            path='/venue/:venueId/fulfillment-centers/:fulfillmentCenterId/delivery/layout'
            component={FulfillmentCenterDeliveryManagementRoutes.FulfillmentCentersDeliveryLayout}
            exact={true}
          />
          <PrivateRoute
            path='/venue/:venueId/fulfillment-centers/:fulfillmentCenterId/delivery/layout/:parentLocationId'
            component={FulfillmentCenterDeliveryManagementRoutes.FulfillmentCentersDeliveryLayout}
          />
          <PrivateRoute
            path='/venue/:venueId/fulfillment-centers/:fulfillmentCenterId/assignments'
            component={FulfillmentCenterDeliveryManagementRoutes.ServerAssignments}
            exact={true}
          />
          <PrivateRoute
            path='/venue/:venueId/fulfillment-centers/:fulfillmentCenterId/assignments/:serverId'
            component={FulfillmentCenterDeliveryManagementRoutes.CurrentAssignments}
            exact={true}
          />
          <PrivateRoute
            path='/venue/:venueId/fulfillment-centers/:fulfillmentCenterId/assignments/:serverId/edit'
            component={FulfillmentCenterDeliveryManagementRoutes.EditAssignments}
            exact={true}
          />
          <PrivateRoute
            path='/venue/:venueId/fulfillment-centers/:fulfillmentCenterId/assignments/:serverId/add'
            component={FulfillmentCenterDeliveryManagementRoutes.AddTables}
            exact={true}
          />
          <PrivateRoute
            path='/venue/:venueId/fulfillment-centers/:fulfillmentCenterId/live-stats'
            component={FulfillmentCenterDeliveryManagementRoutes.LiveDeliveryStats}
            exact={true}
          />
          <PrivateRoute
            path='/venue/:venueId/fulfillment-centers/:fulfillmentCenterId/live-stats/:parentId'
            component={FulfillmentCenterDeliveryManagementRoutes.LiveDeliveryStats}
            exact={true}
          />

          <PrivateRoute
            path='/venue/:venueId/fulfillment-centers/:fulfillmentCenterId/live-delivery-report'
            component={ReportRoutes.LiveDeliveryReport}
            exact={true}
          />

          <PrivateRoute
            exact={true}
            path='/venue/:venueId/menu/:menuId/category/:categoryId/add'
            component={MenuRoutes.AddMenuItem}
          />
          <PrivateRoute
            exact={true}
            path='/venue/:venueId/menu/:menuId/category/:categoryId/item/:id'
            component={MenuRoutes.EditMenuItem}
          />
          <PrivateRoute exact={true} path='/venue/:venueId/menu/list' component={MenuRoutes.MenuLanding} />
          <PrivateRoute exact={true} path='/venue/:venueId/menu/list/:menuId' component={MenuRoutes.MenuContainer} />
          <PrivateRoute
            exact={true}
            path='/venue/:venueId/menu/list/:menuId/category/:categoryId'
            component={MenuRoutes.MenuContainer}
          />

          <PrivateRoute exact={true} path='/venue/:venueId/manage' component={VenueManageRoutes.ManageContainer} />
          <PrivateRoute exact={true} path='/venue/:venueId/order' component={OrderRoutes.Orders} />

          <PrivateRoute exact={true} path='/venue/:venueId/reports/sessions' component={ReportRoutes.Sessions} />
          <PrivateRoute
            exact={true}
            path='/venue/:venueId/reports/disbursements'
            component={ReportRoutes.Disbursements}
          />

          <PrivateRoute exact={true} path='/venue/:venueId/users' component={UserRoutes.ManagementContainer} />
          <Route exact={true} path='/user-invite/:id' component={UserRoutes.UserInvite} />

          <PrivateRoute path='/home' component={Home} />
        </Switch>
      </ApolloProvider>
    );
  }
}
